import { Avatar, AvatarProps } from '@mui/material';

interface Props extends Omit<AvatarProps, 'src' | 'children'> {
  userId: string;
  displayName: string;
  size?: number;
}

/**
 * Avatar that fetches the user's profile photo from Graph via our /api/users/:id/photo proxy.
 * Falls back to initials over a colored background when no photo exists.
 */
export function UserAvatar({ userId, displayName, size = 40, sx, ...rest }: Props) {
  const initials = displayName.split(' ').map(p => p[0]).slice(0, 2).join('').toUpperCase();
  return (
    <Avatar
      src={`/api/users/${userId}/photo`}
      sx={{
        width: size,
        height: size,
        fontSize: size * 0.4,
        background: 'linear-gradient(135deg, #4ea8ff 0%, #7e5cd9 100%)',
        ...sx,
      }}
      imgProps={{ loading: 'lazy', referrerPolicy: 'no-referrer' }}
      {...rest}
    >
      {initials}
    </Avatar>
  );
}
